<ng-container *ngIf="brand.slug === 'fiat'">
  <ng-container *ngFor="let label of offer.labels">
    <div class="promo-label-bottom" *ngIf="brand.slug === 'fiat' && label === 'FCASTOCK3-663-FIAT'">CUDOWNE PRZESILENIE</div>
  </ng-container>
</ng-container>
<ng-container *ngIf="brand.slug !== 'jeep' && brand.slug !== 'alfa-romeo' && brand.slug !== 'fiat' && brand.slug !== 'fiat-professional'">
  <ng-container *ngFor="let label of offer.labels">
    <span class="label label--promo" *ngIf="label === 'FCASTOCK3-663-FIAT'">CUDOWNE PRZESILENIE<span class="only-in-offer">: dodatkowe rabaty tylko do 30 czerwca</span></span>
  </ng-container>
</ng-container>
<ng-container *ngIf="brand.slug === 'jeep'">
  <ng-container *ngFor="let label of offer.labels">
    <span class="label label--miraculous-solstice" *ngIf="label === 'FCASTOCK3-663-JEEP'">CUDOWNE PRZESILENIE<br />Z pakietem korzyści do 33&nbsp;100&nbsp;zł</span>
  </ng-container>
</ng-container>
<ng-container *ngIf="brand.slug === 'alfa-romeo'">
  <ng-container *ngFor="let label of offer.labels">
<!--    <span class="label label&#45;&#45;promo" *ngIf="label === 'FCASTOCK3-663-AR'">Ubezpieczenie AC/OC za&nbsp;1&nbsp;zł</span>-->
    <span class="label label--promo" *ngIf="label === 'FCASTOCK3-663-AR'">Cudowne przesilenie</span>
  </ng-container>
</ng-container>
